import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Remembers where the report was started from so the form's close button and
// its post-submit confirmation can return the user to that exact page.
const ReportRail = () => {
  const location = useLocation();
  const from = `${location.pathname}${location.search}`;

  return (
    // Sticky like the left sidebar — stays in view while the body scrolls.
    // self-start stops the flex row stretching it to full height, which would
    // defeat position: sticky.
    // Width steps down on smaller screens. At 320px it left the content column
    // too narrow to hold the alerts table. w-64 rather than w-56 below xl: the
    // root font size drops there too, so the rail shrinks in px as well, and
    // any narrower wrapped the heading onto a second line and made its rule
    // deeper than the sidebar's and the tagline's.
    <aside className="w-64 flex-shrink-0 sticky top-6 self-start xl:w-72 2xl:w-80">
      <h2 className="text-lg text-black flex items-center min-h-[2.75rem] border-t border-b border-black">
        Report a new fraud or scam?
      </h2>
      <p className="text-black mt-6 leading-relaxed">
        Learn about a new scam to warn help others from being victimized.
      </p>
      <Link
        to="/dashboard/report"
        state={{ from }}
        className="block w-full mt-8 bg-black text-white text-center text-lg py-2.5 rounded-lg border-2 border-gray-700 hover:bg-gray-900 transition-colors"
      >
        Report
      </Link>
    </aside>
  );
};

export default ReportRail;
